<template>
    <div id="memberClubFeeErrors">
        <table class="kgr-table kgr-table--striped table-groups kgr-row">
            <thead>
                <tr class="kgr-table_row">
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ tFirstName }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ tLastName }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ tFeeName }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ tErrorMessage }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="error in errorList"
                    :key="error.entity.id"
                    class="kgr-table_row"
                >
                    <td class="kgr-table__cell">
                        {{ error.entity.firstName }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ error.entity.lastName }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ error.entity.feeName }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ error.errorMessage }}
                    </td>
                </tr>
            </tbody>
        </table>
        <button
            v-if="hasMoreErrors"
            class="kgr-button kgr-button--secondary"
            @click="showMore"
        >
            {{ tShowMore }}
        </button>
    </div>
</template>

<script>
export default {
    props: {
        errors: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            numberOfResults: 10,
        };
    },
    computed: {
        errorList() {
            return this.errors.slice(0, this.numberOfResults);
        },
        hasMoreErrors() {
            return this.errors.length > this.errorList.length;
        },
        tFirstName() {
            return this.$t('member.firstName');
        },
        tLastName() {
            return this.$t('member.lastName');
        },
        tFeeName() {
            return this.$t('Lists.actions.errors.MemberClubFee.feeName');
        },
        tErrorMessage() {
            return this.$t('Lists.actions.errors.errorMessage');
        },
        tShowMore() {
            return this.$t('Lists.actions.errors.showMore');
        },
    },
    methods: {
        showMore() {
            this.numberOfResults += 10;
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
#memberClubFeeErrors {
    max-height: 450px;
    overflow-y: auto;
}
</style>
